import React from 'react';
import { ReactComponent as Logo } from '../assets/app-manager-logo.svg';

interface AppManagerLogoProps {
  height?: number;
  width?: number | string;
  className?: string;
}

export const AppManagerLogo: React.FC<AppManagerLogoProps> = ({ height = 24, width = 'auto', className }) => {
  return <Logo style={{ height, width }} className={className} />;
};
